import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import LoadingImage from '../Images/loading.gif';
import ErrorPage from './Errorpage';

const Member360 = () => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [debugInfo, setDebugInfo] = useState(null);
    const location = useLocation();
    const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
    const hasCalledAPI = useRef(false);

    useEffect(() => {
        // Prevent duplicate calls
        if (hasCalledAPI.current) return;
        
        try {
            window.history.pushState("you are being redirected...", "Redirect", "/redirect");
        } catch (err) {
            if (typeof console !== 'undefined') console.log(err);
        }

        const queryParams = new URLSearchParams(location.search);
        const params = {};

        // Dynamically extract all query parameters
        queryParams.forEach((value, key) => {
            params[key] = value;
        });

        // Set default module if not provided
        if (!params.module) {
            params.module = 'Member360';
        }

        console.log('Extracted Member360 Params:', params);

        // Mark that we're about to call the API
        hasCalledAPI.current = true;
        fetchMember360URL(params);
    }, [location]); 

    const fetchMember360URL = async (params) => {
        try {
            console.log('API Request Params:', params);

            const response = await axios.get(`${API_URL}/api/Member360/GetMember360Url`, {
                params: {
                    ...params
                }
            });

            console.log('API Response:', response.data);

            // Handle API response structure
            if (response.data && response.data.success && response.data.data) {
                const member360Data = response.data.data;
                
                // Store debug information
                setDebugInfo({
                    memberId: member360Data.memberId,
                    stateName: member360Data.stateName,
                    authType: member360Data.authenticationType,
                    shouldRedirect: member360Data.shouldRedirect
                });
                
                // Check if we should redirect and have a URL
                if (member360Data.shouldRedirect && member360Data.redirectUrl) {
                    // Direct redirection to the main URL
                    console.log('Redirecting to:', member360Data.redirectUrl);
                    window.location.href = member360Data.redirectUrl;
                } else if (member360Data.manualRedirectUrl) {
                    // Fallback to manual redirect URL
                    console.log('Using manual redirect URL:', member360Data.manualRedirectUrl);
                    window.location.href = member360Data.manualRedirectUrl;
                } else {
                    // Show error if no redirect URL available
                    setLoading(false);
                    setError('member360');
                    console.error('No redirect URL available:', member360Data.errorMessage || 'Unknown error');
                }
            } else {
                // Handle API failure or unsuccessful response
                setLoading(false);
                setError('member360');
                const errorMessage = response.data?.message || 'Failed to get Member360 URL';
                console.error('API Error:', errorMessage);
            }
        } catch (error) {
            console.error('Error fetching Member360 URL:', error);
            setLoading(false);
            
            // Handle different types of errors
            if (error.response) {
                // Server responded with error status
                console.error('Server Error Response:', error.response.data);
                const errorMessage = error.response.data?.message || 'Server error occurred';
                console.error('Server Error Message:', errorMessage);
            } else if (error.request) {
                // Network error
                console.error('Network Error - No response received');
            } else {
                // Other error
                console.error('Request Error:', error.message);
            }
            
            setError('member360');
        }
    };

    return (
        <div>
            <table style={{ backgroundColor: 'transparent' }} cellPadding="0" cellSpacing="0">
                <tbody>
                    <tr style={{ height: '30%' }}>
                        <td></td>
                    </tr>
                    <tr>
                        <td style={{ width: '30%' }}></td>
                        <td align="center" style={{ fontSize: 'x-large' }}>
                            {error && <ErrorPage errorType="member360" />}
                        </td>
                        <td style={{ width: '30%' }}></td>
                    </tr>
                    <tr>
                        <td style={{ width: '50%' }}></td>
                        <td align="center" style={{ fontSize: 'large' }}>
                            {loading && (
                                <div>
                                    <div style={{ float: 'left' }}>
                                        <img src={LoadingImage} id="loadinggif" alt="Loading" />
                                    </div>
                                    <div style={{ float: 'left' }} id="loadingtext">
                                        Loading Member360...
                                    </div>
                                </div>
                            )}
                        </td>
                        <td style={{ width: '50%' }}></td>
                    </tr>
                    <tr>
                        <td style={{ width: '30%' }}></td>
                        <td align="center">
                            <div style={{ fontSize: 'larger' }}></div>
                        </td>
                        <td style={{ width: '30%' }}></td>
                    </tr>
                    <tr style={{ height: '30%' }}>
                        <td></td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default Member360;
